import { applyFilters } from '@wordpress/hooks';
import { useSelect, select, dispatch, withSelect } from '@wordpress/data';
import { _n, __ } from '@wordpress/i18n';
import { TextControl, PanelRow } from '@wordpress/components';

// Feilds.
import TripEnquiryFields from './fields/TripEnquiryFields';
import BillingFields from './fields/BillingFields';
import TravelerFields from './fields/TravelerFields';

import { useState, useEffect } from '@wordpress/element';

export default () => {

    const settings = useSelect((select) => {
        return select('WPTravel/Admin').getAllStore()
    }, []);
    const { updateSettings } = dispatch('WPTravel/Admin');
    const { options, modules } = settings
    const { default_settings } = options;
    const { modules:defaultModules } = default_settings;
    const moduleSettings = 'undefined' !== typeof modules && Object.keys( modules ).length > 0 ? modules : defaultModules;
   
    let recaptcha_v2_site_key = 'undefined' != typeof settings.recaptcha_v2_site_key ? settings.recaptcha_v2_site_key : ''
    let recaptcha_v2_secret_key = 'undefined' != typeof settings.recaptcha_v2_secret_key ? settings.recaptcha_v2_secret_key : ''

    const isActive  = 'undefined' !== typeof moduleSettings && 'undefined' !== typeof moduleSettings.show_wp_travel_field_editor && 'yes' === moduleSettings.show_wp_travel_field_editor.value;
    if ( ! isActive ) {
        // To hide while disabling from addons settings.
        return <></>;
    }
    return <>
    <h3>{_wp_travel.setting_strings.recaptcha_v2.recaptcha_checkbox}</h3>
        <PanelRow>
            <label>{ _wp_travel.setting_strings.recaptcha_v2.re_site_key }</label>
            <div id="wp-travel-recaptcha-v2-site-key" className="wp-travel-field-value">
                <TextControl
                    value={recaptcha_v2_site_key}
                    onChange={ 
                        (value) => {
                            updateSettings({
                                ...settings,
                                recaptcha_v2_site_key: value
                            })
                        }
                    }
                />
                <p className="description">{ _wp_travel.setting_strings.recaptcha_v2.re_site_note }<a href="https://www.google.com/recaptcha/" target="_blank">reCAPTCHA site key.</a>.</p>
            </div>
        </PanelRow>
        <PanelRow>
            <label>{ _wp_travel.setting_strings.recaptcha_v2.re_secret_key }</label>
            <div id="wp-travel-recaptcha-v2-secret-key" className="wp-travel-field-value">
                <TextControl
                    value={recaptcha_v2_secret_key}
                    onChange={ 
                        (value) => {
                            updateSettings({
                                ...settings,
                                recaptcha_v2_secret_key: value
                            })
                        }
                    }
                />
                <p className="description">{ _wp_travel.setting_strings.recaptcha_v2.re_site_note }<a href="https://www.google.com/recaptcha/" target="_blank">reCAPTCHA secret key.</a>.</p>

            </div>
        </PanelRow>
    
    </>
    
}

